import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import Selects from "../../biblio/Selects/Selects";
import SurveyCollapse from "./SurveyCollapse";
import DotsLoader from "../../biblio/Loader/DotsLoader";
import moment from "moment";
import { surveyOptions } from "../../data/data";
import { useSelector } from "react-redux";
import { RootState } from "../../apis/store";
interface surveyProps {
  survey: any;
  loading: boolean;
}
const SurveyOverview = ({ survey, loading }: surveyProps) => {
  const [sortedSurvey, setSortedSurvey] = useState<any[]>([]);
  const [selectedBy, setSelectedBy] = useState<string | null>(null);
  const { type } = useSelector((state: RootState) => state.survey);

  useEffect(() => {
    let list =
      selectedBy === "الأحدث"
        ? [...survey].sort(
            (a: any, b: any) =>
              moment(b.publication_date, "YYYY-MM-DD HH:mm:ss").valueOf() -
              moment(a.publication_date, "YYYY-MM-DD HH:mm:ss").valueOf()
          )
        : selectedBy === "الأقدم"
        ? [...survey].sort(
            (a: any, b: any) =>
              moment(a.publication_date, "YYYY-MM-DD HH:mm:ss").valueOf() -
              moment(b.publication_date, "YYYY-MM-DD HH:mm:ss").valueOf()
          )
        : survey;
    setSortedSurvey(list);
  }, [survey, selectedBy]);

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedBy(value?.label);
    } else {
      setSelectedBy(null);
    }
  };
  return (
    <>
      <Row gutter={8} dir="rtl">
        <Col
          xxl={type === "external" ? 20 : 18}
          xl={type === "external" ? 20 : 18}
          lg={type === "external" ? 20 : 18}
          md={6}
          sm={24}
          xs={24}
        >
          <span
            className="takaful--service-section-title takaful--survey-title"
            style={{ fontSize: type === "external" ? "" : "1.38rem" }}
          >
            قائمة التقييمات
          </span>
        </Col>
        <Col
          xxl={type === "external" ? 4 : 6}
          xl={type === "external" ? 4 : 6}
          lg={type === "external" ? 4 : 6}
          md={type === "external" ? 4 : 6}
          sm={24}
          xs={24}
          style={{marginTop:"0.6rem"}}
        >
          <Selects
            options={surveyOptions}
            selectPlaceholder="اختر الترتيب"
            onChange={handleSelectChange}
            allowClear={true}
            className="takaful--evaluation-select takaful--request-select"
            popupClassName="takaful--service-select-dropdown"
          />
        </Col>
      </Row>
      {loading ? (
        <div className="takaful--loading-projects-cases">
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : survey?.length === 0 ? (
        <p className="takaful--no-services">لا توجد تقييمات</p>
      ) : (
        <>
          <Row gutter={8} dir="rtl" style={{ marginTop:type === "external"?"": "2rem" }}>
            <SurveyCollapse
              survey={sortedSurvey}
            />
          </Row>
        </>
      )}
    </>
  );
};

export default SurveyOverview;
